import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, onSnapshot, collection, getDocs, addDoc, updateDoc, serverTimestamp, query, where, deleteDoc, writeBatch, limit, enableMultiTabIndexedDbPersistence } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCQfDAEZv9tixb4cwSjZXYro14OdV7e_LA",
  authDomain: "album-mundial-2026-ca67b.firebaseapp.com",
  projectId: "album-mundial-2026-ca67b",
  storageBucket: "album-mundial-2026-ca67b.firebasestorage.app",
  messagingSenderId: "423117479830",
  appId: "1:423117479830:web:538d2880db4d633c1c47b7",
  measurementId: "G-D5Q83SENX3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

if (typeof window !== "undefined") {
  enableMultiTabIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn("La persistencia falló: múltiples pestañas abiertas.");
    } else if (err.code === 'unimplemented') {
      console.warn("El navegador no soporta persistencia.");
    }
  });

  // Firebase Messaging registers its own service worker (firebase-messaging-sw.js)
  // automatically when getToken() is first called — we don't register it manually
  // here so it doesn't conflict with the Workbox SW (vite-plugin-pwa) that
  // claims the root scope for offline caching.
}

export { 
  app, 
  auth, 
  db, 
  googleProvider, 
  signInWithPopup, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signOut,
  doc, 
  setDoc, 
  getDoc, 
  onSnapshot,
  collection,
  getDocs,
  addDoc,
  updateDoc,
  serverTimestamp,
  query,
  where,
  deleteDoc,
  writeBatch,
  limit
};
